import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { SupplierQueryParams } from './hooks/useFetchSuppliers';
import FilterBox from 'components/filter-box/FilterBox';
import CpfCnpjInput from 'components/masked-input/CpfCnpjInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 200px 100px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type SupplierFilterBoxProps = {
  filter: SupplierQueryParams;
  handleChange<K extends keyof SupplierQueryParams>(index: K, value: SupplierQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const SupplierFilterBox: React.FC<SupplierFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome da empresa"
          placeholder="Digite o nome da empresa"
          value={filter.company_name}
          autoFocus
          onChange={e => handleChange('company_name', e.target.value)}
        />

        <TextField
          fullWidth
          label="CPF/CNPJ"
          placeholder="Digite o CPF/CNPJ"
          value={filter.document_number}
          onChange={e => handleChange('document_number', e.target.value)}
          slotProps={{
            input: {
              inputComponent: asInputComponent(CpfCnpjInput),
            },
          }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default SupplierFilterBox;
